import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }) {
  const { isLoggedIn, isInitialized } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Wait for the stored session to be restored before deciding to redirect,
    // otherwise a page refresh bounces through /login and drops router state.
    if (isInitialized && !isLoggedIn) {
      navigate('login', {
        state: {
          from: location.pathname,
          fromState: location.state
        },
        replace: true
      });
    }
  }, [isInitialized, isLoggedIn, navigate, location]);

  if (!isInitialized) return <Loader />;

  return children;
}

AuthGuard.propTypes = { children: PropTypes.any };
